export const PATIENT_CURRENT_REPORT_OPTIONS = {
  APPOINTMENT_DATE_TIME: "Patient.CurrentReport.AppointmentDateTime",
  APPOINTMENT_TYPE: "Patient.CurrentReport.AppointmentType",
  LEFT_HEARING_LOSS: "Patient.CurrentReport.LeftHearingLoss",
  RIGHT_HEARING_LOSS: "Patient.CurrentReport.RightHearingLoss",
  LEFT_WRS_PRESENTATION_LEVEL_LOSS:
    "Patient.CurrentReport.LeftWRSAndPresentationLevel",
  RIGHT_WRS_PRESENTATION_LEVEL_LOSS:
    "Patient.CurrentReport.RightWRSAndPresentationLevel",
  LEFT_QUICKSIN_AND_SNR_LOSS: "Patient.CurrentReport.LeftQuickSinAndSnrLoss",
  RIGHT_QUICKSIN_AND_SNR_LOSS: "Patient.CurrentReport.RightQuickSinAndSnrLoss",
  LEFT_TYMPANOGRAM_TYPE: "Patient.CurrentReport.LeftTympanogramType",
  RIGHT_TYMPANOGRAM_TYPE: "Patient.CurrentReport.RightTympanogramType",
  LEFT_HEARING_LOSS_LEVEL: "Patient.CurrentReport.LeftHearingLossLevel",
  RIGHT_HEARING_LOSS_LEVEL: "Patient.CurrentReport.RightHearingLossLevel",
  LEFT_HEARING_LOSS_SHAPE: "Patient.CurrentReport.LeftHearingLossShape",
  RIGHT_HEARING_LOSS_SHAPE: "Patient.CurrentReport.RightHearingLossShape",
  LEFT_HEARING_LOSS_TYPE: "Patient.CurrentReport.LeftHearingLossType",
  RIGHT_HEARING_LOSS_TYPE: "Patient.CurrentReport.RightHearingLossType",
  SUMMARY: "Patient.CurrentReport.Summary"
};

export const PATIENT_CURRENT_REPORT_MENU_OPTIONS = {
  title: "Patient - Current Report",
  menu: [
    {
      title: "Patient - Current Report - Appointment Date Time",
      value: PATIENT_CURRENT_REPORT_OPTIONS.APPOINTMENT_DATE_TIME
    },
    {
      title: "Patient - Current Report - Appointment Type",
      value: PATIENT_CURRENT_REPORT_OPTIONS.APPOINTMENT_TYPE
    },
    {
      title: "Patient - Current Report - Left Ear",
      menu: [
        {
          title: "Patient - Current Report - Left Hearing Loss",
          value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_HEARING_LOSS
        },
        {
          title:
            "Patient - Current Report - Left WRS and Presentation Level",
          value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_WRS_PRESENTATION_LEVEL_LOSS
        },
        {
          title: "Patient - Current Report - Left QuickSIN and SNR Loss",
          value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_QUICKSIN_AND_SNR_LOSS
        },
        {
          title: "Patient - Current Report - Left Tympanogram Type",
          value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_TYMPANOGRAM_TYPE
        },
        {
          title: "Patient - Current Report - Left Hearing Loss Level",
          value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_HEARING_LOSS_LEVEL
        },
        {
          title: "Patient - Current Report - Left Hearing Loss Shape",
          value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_HEARING_LOSS_SHAPE
        },
        {
          title: "Patient - Current Report - Left Hearing Loss Type",
          value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_HEARING_LOSS_TYPE
        }
      ]
    },
    {
      title: "Patient - Current Report - Right Ear",
      menu: [
        {
          title: "Patient - Current Report - Right Hearing Loss",
          value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_HEARING_LOSS
        },
        {
          title:
            "Patient - Current Report - Right WRS and Presentation Level",
          value:
            PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_WRS_PRESENTATION_LEVEL_LOSS
        },
        {
          title: "Patient - Current Report - Right QuickSIN and SNR Loss",
          value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_QUICKSIN_AND_SNR_LOSS
        },
        {
          title: "Patient - Current Report - Right Tympanogram Type",
          value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_TYMPANOGRAM_TYPE
        },
        {
          title: "Patient - Current Report - Right Hearing Loss Level",
          value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_HEARING_LOSS_LEVEL
        },
        {
          title: "Patient - Current Report - Right Hearing Loss Shape",
          value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_HEARING_LOSS_SHAPE
        },
        {
          title: "Patient - Current Report - Right Hearing Loss Type",
          value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_HEARING_LOSS_TYPE
        }
      ]
    },
    {
      title: "Patient - Current Report - Summary",
      value: PATIENT_CURRENT_REPORT_OPTIONS.SUMMARY
    }
  ]
};
